import(/* webpackMode: "eager" */ "/app/apps/galatea-web/src/app/global-error.tsx");
